import { useHideDOMElement } from "./useHideDOMElement";

export const useHideTrialBanner = () => useHideDOMElement(".bottom-banner");
export const useHideMainHeader = () => useHideDOMElement("#mainHeader");
